module.exports = __webpack_public_path__ + "bf717c6.webp";